<div
    class="flex-grow text-center flex flex-col gap-4"
    [class]="isMapOneThirdHorizontal() ? 'mt-8vh' : 'mt-3vh'">
    @if (isMapOneThirdHorizontal()) {
        <fa-icon
            class="!text-custom-blue"
            [icon]="icon()"
            [size]="size()" />
    }
    <span class="text-4xl font-normal">{{ title() | transloco }}</span>
    <span class="text-xl font-light">{{ subTitle() | transloco }}</span>
</div>
